<p-confirmDialog />
<app-skeleton  id="table-items" *ngIf="loading" [columns]="tableConfig" [paginator]="true"></app-skeleton>
<div class="table-responsive" *ngIf="!loading">
    <app-primeng-table 
      [tableData]="tableData" 
      [columns]="tableConfig" 
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [responsiveLayout]="'scroll'"
      [styleClass]="'p-datatable-gridlines'"
      [isFilterRequired]="true"
      [customTemplates]="{'action': action, 'status': status, 'roleNames': roleNames, 'applicationNames': applicationNames}"
    >
    </app-primeng-table>
    <ng-template #status let-rowData="rowData" let-index="index">
      <td>
        <span class="font-weight-bold"
         [ngClass]="rowData?.status === 'Active' ? 'text-success':'text-red-500'" >{{rowData?.status}}</span>
      </td>
    </ng-template>

    <ng-template #roleNames let-rowData="rowData">
      <td>
        <div class="chips  flex gap-1 flex-wrap">
          <ng-container *ngFor="let row of rowData.applicationRolesDetailsList; let i = index">
            @if(row.roleName) {
              <p-chip  pTooltip="{{row.roleName}}" 
                tooltipPosition="top"  [label]="row.roleName | truncate:10"></p-chip>
            }
            @else {
              -
            }
          </ng-container>
        </div>
      </td>
    </ng-template>
    <ng-template #applicationNames let-rowData="rowData">
      <td>
        <div class="chips flex gap-1 flex-wrap">
          <ng-container *ngFor="let row of rowData.applicationRolesDetailsList; let i = index">
            @if (row.applicationName) {
              <p-chip  pTooltip="{{row.applicationName}}" 
                  tooltipPosition="top"  [label]="row.applicationName | truncate:10"></p-chip>
            }
            @else {
              -
            }
          </ng-container>
        </div>
      </td>
    </ng-template>
    <ng-template #action let-rowData="rowData" let-rowIndex="rowIndex">
      <td>
        <div class="flex">
          <p-button size="small" pTooltip="edit" (onClick)="handleOptionClick(rowData,'Edit')" [text]="true" [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg" name="edit"></i-tabler>
          </p-button>
          <p-button size="small" pTooltip="View" (onClick)="handleOptionClick(rowData,'View')" [text]="true" [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg" name="eye"></i-tabler>
          </p-button>
          <p-button size="small" pTooltip="Delete" (onClick)="handleOptionClick(rowData,'Delete')" [text]="true" [raised]="false" severity="secondary">
            <i-tabler class="ti-normal ti-lg " name="trash"></i-tabler>
          </p-button>
        </div>
      </td>
    </ng-template>

</div>
